import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { Language } from '../../../../../shared/enum/language';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';


@Component({
  selector: 'admin-campaign-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminUserListComponent extends AbstractListComponent implements OnInit {

  languages: any = Language;

  getResourceUrl(): string {
    return '/admin/user';
  }

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route);
  }

  ngOnInit() {
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Users',
      url: '/admin/user'
    });

    super.ngOnInit();
  }
}
